import {DefaultEventsMap, DeviceType, Rectangle} from '@gongxigames/framework/core';
import {
    WaterMarkView,
    WaterMarkViewInitData,
    WaterMarkViewMobileLandscape,
    WaterMarkViewMobilePortrait
} from '@gongxigames/framework/slot/modules/watermark';
import {LAYERS} from '@gongxigames/framework/slot/configs/Layers';
import {ScreenOrientedView} from '@gongxigames/framework/slot/fragments/module/view';

export class WaterMarkViewMobile extends ScreenOrientedView<DefaultEventsMap, WaterMarkView> {
    public static readonly NAME: symbol = Symbol('WaterMarkViewMobile');
    public static layer = LAYERS.WATERMARK;
    public static platform: DeviceType = DeviceType.MOBILE;

    protected landscapeViewName: symbol = WaterMarkViewMobileLandscape.NAME;
    protected portraitViewName: symbol = WaterMarkViewMobilePortrait.NAME;

    public updateGlobalClock(globalTime: string): void {
        this.forEachViews((view: WaterMarkView) => {
            view.updateGlobalClock(globalTime);
        });
    }
    public updateElapsedTimeClock(elapsedTime: string): void {
        this.forEachViews((view: WaterMarkView) => {
            view.updateElapsedTimeClock(elapsedTime);
        });
    }

    public updateSessionBalance(value: string): void {
        this.forEachViews((view: WaterMarkView) => {
            view.updateSessionBalance(value);
        });
    }

    public switchOnNetPosition(): void {
        this.forEachViews((view: WaterMarkView) => {
            view.switchOnNetPosition();
        });
    }

    public show(): void {
        this.forEachViews((view: WaterMarkView) => {
            view.show();
        });
    }

    public switchOnGlobalClock(): void {
        this.forEachViews((view: WaterMarkView) => {
            view.switchOnGlobalClock();
        });
    }

    public setMenuBarOffsets(isAddOffset: boolean): void {
        this.forEachViews((view: WaterMarkView) => {
            view.setMenuBarOffsets(isAddOffset);
        });
    }

    public set isFullscreen(value: boolean) {
        this.forEachViews((view: WaterMarkView) => {
            view.isFullscreen = value;
        });
    }

    public initProperties(data: WaterMarkViewInitData): void {
        this.forEachViews((view: WaterMarkView) => {
            view.initProperties(data);
        });
    }

    public updateSessionBet(value: string): void {
        this.forEachViews((view: WaterMarkView) => {
            view.updateSessionBet(value);
        });
    }

    public updateSessionEarnings(value: string): void {
        this.forEachViews((view: WaterMarkView) => {
            view.updateSessionEarnings(value);
        });
    }

    public updateBalanceFieldBounds(bounds: Rectangle): void {
        this.forEachViews((view: WaterMarkView) => {
            view.updateBalanceFieldBounds(bounds);
        });
    }

    public updateMaxWinProbability(value: string): void {
        this.forEachViews((view: WaterMarkView) => {
            view.updateMaxWinProbability(value);
        });
    }

    public updateRTPWatermark(value: string): void {
        this.forEachViews((view: WaterMarkView) => {
            view.updateRTPWatermark(value);
        });
    }
}
